import { render, staticRenderFns } from "./OverviewUserManagement.vue?vue&type=template&id=2295c27b&"
import script from "./OverviewUserManagement.vue?vue&type=script&lang=js&"
export * from "./OverviewUserManagement.vue?vue&type=script&lang=js&"
import style0 from "./OverviewUserManagement.vue?vue&type=style&index=0&id=2295c27b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports